import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { v4 as uuid } from "uuid";

// Components
import BaseInputComponent from "basecomponents/BaseInputComponent";
import { InputField } from "../components/form";
import { Button } from "../components/button";
import { LoaderDots, Empty } from "../components/loaders";

import AdminAddUserModal from "modals/AdminAddUserModal";
import AdminEditUserModal from "modals/AdminEditUserModal";

// Utils
import { showModal, showPopUpConfirmation, showPopUp } from "../utils/domUtils";

// Actions
import {
  getUsers,
  setEditUserFromFunction,
  deleteUser,
} from "../actions/userActions";

// Interfaces
import { IUser } from "../interfaces/IUser";
class AdminDUsers extends BaseInputComponent {
  state = {
    field: "",
    idmodal_add_user: "modal_add_user",
    idmodal_edit_user: "modal_edit_user",
    searching: false,
    searchingResults: [],
  };

  componentDidMount() {
    this.getResults();
  }

  onKeyUpField = () => {
    this.handleSearchManual(() => {
      let field = this.state.field.toLowerCase().trim();
      field = field.length > 0 ? field : null;

      const searching = field !== null;
      let searchingResults = [];

      if (searching) {
        // @ts-ignore
        searchingResults = this.props.user.elements.filter((item: IUser) => {
          return (
            item.name.toLowerCase().indexOf(field) >= 0 ||
            item.email.toLowerCase().indexOf(field) >= 0 ||
            item.user?.toLowerCase()?.indexOf(field) >= 0
          );
        });
      }

      this.setState({
        searching,
        searchingResults,
      });
    });
  };

  getResults(searchData = null) {
    // @ts-ignore
    this.props.getUsers(searchData);
  }

  isLoading(): boolean {
    // @ts-ignore
    return this.props.user.loading;
  }

  getComponentResults(): Array<IUser> {
    if (this.state.searching) {
      return this.state.searchingResults;
    }
    // @ts-ignore
    const results: Array<IUser> = this.props.user.elements;
    return results;
  }

  onAddUserClick = () => {
    showModal(this.state.idmodal_add_user);
  };

  onEditUserClick = (user: IUser) => {
    // @ts-ignore
    this.props.setEditUserFromFunction(user);
    showModal(this.state.idmodal_edit_user);
  };

  onDeleteUserClick = (user: IUser) => {
    showPopUpConfirmation(
      `Realmente desea elminar al usuario "${user.name}"?`,
      "Esta accion removera al usuario y no podra ser utilizado nuevamente, esta accion no es reversible",
      (confirmation) => {
        if (!confirmation) return;
        this.onConfirmDeleteUser(user);
      }
    );
  };

  onConfirmDeleteUser = (user: IUser) => {
    // @ts-ignore
    this.props.deleteUser(user.id, (success) => {
      showPopUp(
        success
          ? "Usuario eliminado correctamente"
          : "Ocurrio un error al eliminar el usuario",
        success
          ? `Usuario ${user.name} eliminado correctamente`
          : "Intente de nuevo en un momento o contacte al administrador de sistema"
      );
    });
  };

  getInputSearch = () => {
    const { field } = this.state;
    return (
      <div className="input-search mb-2">
        <InputField
          id="field"
          name="field"
          placeholder="Buscar..."
          value={field}
          onChange={this.onChangeTextInput}
          onKeyUp={this.onKeyUpField}
        />
      </div>
    );
  };

  getResultsTable = () => {
    const isLoading = this.isLoading();
    if (isLoading) {
      return <LoaderDots />;
    }
    const results = this.getComponentResults();
    if (results.length === 0) {
      return <Empty message="No hay usuarios para mostrar..." />;
    }

    return (
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th></th>
              <th>ID</th>
              <th>Nombre</th>
              <th>Correo</th>
              <th>Usuario</th>
              <th>Administrador</th>
              <th>Activo</th>
              <th>Verificado</th>
              <th>Fecha de creaci&oacute;n</th>
            </tr>
          </thead>
          <tbody>
            {results.map((user) => (
              <tr key={uuid()}>
                <td>
                  <div className="dropdown">
                    <button
                      className="btn btn-link"
                      type="button"
                      id={`dropdown_${user.id}`}
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i className="feather icon-more-vertical-"></i>
                    </button>
                    <div
                      className="dropdown-menu"
                      aria-labelledby={`dropdown_${user.id}`}
                    >
                      <a
                        className="dropdown-item"
                        href="#!"
                        onClick={this.onEditUserClick.bind(this, user)}
                      >
                        <i className="feather icon-edit-2 mr-2"></i>Editar
                      </a>
                      <a
                        className="dropdown-item"
                        href="#!"
                        onClick={this.onDeleteUserClick.bind(this, user)}
                      >
                        <i className="feather icon-trash mr-2"></i>Eliminar
                      </a>
                    </div>
                  </div>
                </td>
                <td>{user.id}</td>
                <td>{user.name}</td>
                <td>{user.email}</td>
                <td>{user.user || ""}</td>
                <td>{user.admin ? "Si" : "No"}</td>
                <td>{user.is_active ? "Si" : "No"}</td>
                <td>{user.is_verified ? "Si" : "No"}</td>
                <td>{user.created_date}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  render() {
    return (
      <>
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <div className="card-title">
                  <span>Listado de usuarios</span>
                  <Button
                    icon="icon-plus"
                    extraClass="btn-primary pull-right"
                    onClick={this.onAddUserClick}
                  />
                </div>
                <div className="card-body">
                  {this.getInputSearch()}
                  {this.getResultsTable()}
                </div>
              </div>
            </div>
          </div>
        </div>

        <AdminAddUserModal />
        <AdminEditUserModal />
      </>
    );
  }
}

// @ts-ignore
AdminDUsers.propTypes = {
  user: PropTypes.object.isRequired,
  getUsers: PropTypes.func.isRequired,
  setEditUserFromFunction: PropTypes.func.isRequired,
  deleteUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps, {
  getUsers,
  setEditUserFromFunction,
  deleteUser,
})(AdminDUsers);
